import { useQuery } from "@blitzjs/rpc"
import getFilterData from "../../../queries/getFilterData"
import PipelineAutocompleteFilterMulti from "app/core/components/Autocomplete/PipelineMultipleAutocomplete"
import { useEffect } from "react"
import React from "react"
import { prepareFilterList } from "../utils/utils"

export default function AdvancedFilters({ filters, onChange, activeFilterOptions }) {
  const [sortedFilterData, setSortedFilterData] = React.useState({
    githubRepositoryPaths: [],
  })

  const [filterData] = useQuery(getFilterData, undefined, { staleTime: Infinity })

  function updateFilters({ field, value }) {
    onChange({
      ...filters,
      [field]: value,
    })
  }

  const filterConfigs = [
    {
      title: "Paths",
      field: "githubRepositoryPath",
      value: filters.githubRepositoryPath,
      collection: [{ name: "All", disable: false }, ...sortedFilterData?.githubRepositoryPaths],
      isDisabled: (item) =>
        item.name !== "All" &&
        activeFilterOptions.githubRepositoryPath.every(
          (active) => active.githubRepositoryPath !== item.name
        ),
      optionValue: (item) => item.name,
      optionLabel: (item) => item.name,
      optionKey: "name",
    },
    {
      title: "Target system",
      field: "targetSystem",
      value: filters.targetSystem,
      collection: ["All", ...filterData.targetSystems],
      optionValue: (item) => item,
      optionLabel: (item) => item,
    },
  ]

  useEffect(() => {
    const updated = {
      githubRepositoryPaths: prepareFilterList(
        filterData.githubRepositoryPaths,
        "githubRepositoryPath",
        "githubRepositoryPath",
        "githubRepositoryPath",
        activeFilterOptions
      ),
    }

    setSortedFilterData(updated)
  }, [activeFilterOptions])

  return (
    <>
      {filterConfigs.map((config, index) => (
        <PipelineAutocompleteFilterMulti
          key={index}
          title={config.title}
          field={config.field}
          value={config.value}
          optionKey={config.optionKey || "name"}
          collection={config.collection}
          isDisabled={config.isDisabled}
          optionValue={config.optionValue}
          optionLabel={config.optionLabel}
          onChange={updateFilters}
        />
      ))}
    </>
  )
}
